import { useContext } from 'react';
import { AfterShipAdsContext } from './AfterShipAds.context';
import type { AfterShipAdsContextValue } from './AfterShipAds.types';

export const useAfterShipAds = (): AfterShipAdsContextValue => {
  const ctx = useContext(AfterShipAdsContext);
  if (!ctx) throw new Error('useAfterShipAds must be used within <AfterShipAdsProvider>');
  return ctx;
};
